module.exports = __webpack_public_path__ + "img/icon-loader-ouri1.b1920a70.svg";